import { render, staticRenderFns } from "./ListTransaksiQRv2.vue?vue&type=template&id=d0633934&"
import script from "./ListTransaksiQRv2.vue?vue&type=script&lang=js&"
export * from "./ListTransaksiQRv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports